import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';
const wave = keyframes `
  0%, 100% {
    height: 8px;
  }
  50% {
    height: 24px;
  }
`;
const wave2 = keyframes `
  0%, 100% {
    height: 12px;
  }
  50% {
    height: 28px;
  }
`;
const wave3 = keyframes `
  0%, 100% {
    height: 16px;
  }
  50% {
    height: 32px;
  }
`;
const wave4 = keyframes `
  0%, 100% {
    height: 10px;
  }
  50% {
    height: 20px;
  }
`;
export const RecordingWaveform = () => {
    const bars = [
        { delay: '0s', animation: wave },
        { delay: '0.1s', animation: wave2 },
        { delay: '0.2s', animation: wave3 },
        { delay: '0.3s', animation: wave4 },
        { delay: '0.4s', animation: wave },
        { delay: '0.5s', animation: wave2 },
        { delay: '0.6s', animation: wave3 },
        { delay: '0.7s', animation: wave4 },
        { delay: '0.8s', animation: wave },
        { delay: '0.9s', animation: wave2 },
    ];
    return (_jsx(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            height: 16,
        }, children: bars.map((bar, index) => (_jsx(Box, { sx: {
                width: 2,
                height: 6,
                backgroundColor: 'text.secondary',
                borderRadius: 1,
                animation: `${bar.animation} 1s ease-in-out infinite`,
                animationDelay: bar.delay,
            } }, index))) }));
};
